
import React, { useEffect, useState } from "react";
import MangeDashboard from "./MangeDashboard";
import axios from "axios";
import { toast } from "react-toastify";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { MdContentCopy } from "react-icons/md";





export default function Oauth(){

    const[key,setKey] = useState('')
    const[qrcode,setQrcode] = useState('')
    const[setup,setSetup] = useState(false)
    const[otp,setOtp] = useState('')
    const[loading,setLoading] = useState(false)

    const [isCopied, setIsCopied] = useState(false);


    const onCopyText = () => {
        setIsCopied(true);
        toast.dismiss()
        
        toast.warning(' کپی شد!', {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            });
};







    useEffect(()=>{

        axios.get('https://api.sinatether.com/Auth/get_qrcode_2fa').then((res)=>{

        if (res.status == 200){

            if (res.data.status == 200)

            {


                setKey(res.data['key'])
                setQrcode(res.data['qr_code'])

                setSetup(false)
                setOtp('')

                
                



            }else{

                setSetup(true)
                setOtp('')


            }
        }



        })
    },[])





    function handleSubmit(){
        setLoading(true)


        axios.post('https://api.sinatether.com/Auth/send_qrcode_2fa',{'token':otp},{withCredentials:true}).then((res)=>{


        if (res.status == 200){


            if (res.data['status'] == 200){

                toast.success(res.data['message'])

                setSetup(res.data['setup'])

                setLoading(false)




            }else{
                toast.error(res.data['message'])
                setLoading(false)

            }




        }





        }).catch((error)=>{

            setLoading(false)

        })




    }


return(


    <MangeDashboard>

        <div className="jfsjhsdbsehraz  align-item-center">
        <div className="container align-items-center setStyleEhraz ">
            <div className={'col-md-12 align-items-center pb5678 text-center'}>


                <div className="google-title2024">

                    <img src="https://static.sinatether.com/images/2fa.svg" alt=""/>

                    <span className="titlw23242">
                     شناسایی دو عاملی


                    </span>



                </div>




                <div>


                </div>

                {setup? 

                <>
                    <div className="jfshf25353623">
                    در حال حاضر شما شناسایی دو عاملی را برای برداشت های خود فعال کرده اید، در صورت تمایل میتوانید این قابلیت را از حساب کاربری خود حذف کنید.
                </div>

                <div className="jfshf25353623 text-danger">
                برای جلوگیری از هر گونه سو استفاده احتمالی، سینا تتر به شما پیشنهاد میدهد که همواره از این قابلیت استفاده کنید.


                </div>

                            <div>

                            <input key={"jsfgsf"} className="bg-custom-input myinput_form  border bg-custom-input input-order667 input-order667 magg6 ginput2023 " value={otp ? otp : ''} placeholder="کد تایید را وارد نمایید" type="tel" onChange={(e)=>setOtp(e.target.value)}/>


                            </div>


                            <div>
                            <button class="btn  btn-danger  gbutton2023 " data-inline="true" onClick={handleSubmit}>

                            {loading ? 
                            <i className="fa fa-spinner fa-spin"></i>

                            :

                            <>
                            ثبت کد و غیرفعالسازی
                            
                            </>

                    }




                            </button>
                            </div>

                </>

                :
                <>


                <div className="jfshf25353623">

                مرحله اول: اپلیکیشن Google Authenticator را بر روی گوشی خود نصب کرده. 



                </div>


                <div>

                    <a href="https://cafebazaar.ir/app/com.google.android.apps.authenticator2?l=en">
                        <img src="https://static.sinatether.com/images/bazar.svg" alt=""/>

                    </a>

                    <a href="https://play.google.com/store/search?q=google+athenticor&c=apps">
                        <img src="https://static.sinatether.com/images/google.svg" alt=""/>

                    </a>


                    <a href="https://apps.apple.com/us/app/google-authenticator/id388497605">
                        <img src="https://static.sinatether.com/images/appstore.svg" alt=""/>

                    </a>


                </div>


                <div className="jfshf25353623">
                مرحله دوم: کد نوشته شده را کپی کرده و در اپلیکیشن Google Authenticator  وارد نمایید و یا میتوانید بارکد پایین را در اپلیکیشن اسکن کنید. 
                </div>



                <div>

                    <img className="height168" src={`data:image/jpg;base64,${qrcode}`} alt=""/>

                    <div>
                    <CopyToClipboard text={key} onCopy={onCopyText}>
                        <span className={'text-large'}>
                           <MdContentCopy/></span>
                        </CopyToClipboard>

                    <span className="fontdfv244">
                    {key}

                    </span>
                    </div>

                </div>


                <div className="jfshf25353623">

                مرحله سوم : کد موجود در اپلیکیشن را کپی کرده و در کادر زیر وارد نمایید.
                </div>


                <div>

                    <input key={"otp2"} className="bg-custom-input myinput_form  border bg-custom-input input-order667 input-order667 magg6 ginput2023" value={otp ? otp : ''} placeholder="کد تایید را وارد نمایید" type="tel" onChange={(e)=>setOtp(e.target.value)}/>


                </div>


                <div>
                <button class="btn  btn-success btsubmit2020 gbutton2023 " data-inline="true" onClick={handleSubmit}>

                    {loading ? 
                            <i className="fa fa-spinner fa-spin"></i>

                            :

                            <>
                            ثبت کد و فعالسازی
                            
                            </>

                    }





                </button>
                </div>
                </>
                }






                        



            </div>





            </div>

        </div>



    


    </MangeDashboard>



)





}